"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = exports.GroupActionButtons = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _CheckInCircle = _interopRequireDefault(require("@insided/shared/icons/CheckInCircle"));

var _MoreHoriz = _interopRequireDefault(require("@insided/shared/icons/MoreHoriz"));

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var _index = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/dropdown/index"));

var _classnames = _interopRequireDefault(require("classnames"));

var _GroupAddMembersModal = _interopRequireDefault(require("./GroupAddMembersModal"));

var _GroupEditFeaturedTopicsModal = _interopRequireDefault(require("./GroupEditFeaturedTopicsModal"));

var _message = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/message"));

var _service = require("./service");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'group-action-buttons';
exports.cssAnchorName = cssAnchorName;

var pageReload = function pageReload() {
  window.location.reload();
};

var redirectToGroupsOverview = function redirectToGroupsOverview() {
  window.location.href = (0, _absoluteUrlRuntime.resolveUrl)('/groups');
};

var GroupActionButtons = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupActionButtons, _Component);

  var _super = _createSuper(GroupActionButtons);

  function GroupActionButtons() {
    var _this;

    (0, _classCallCheck2.default)(this, GroupActionButtons);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      showAddMembersModal: false,
      showEditFeaturedTopicsModal: false,
      showMessage: false,
      messageStatus: 'success',
      messageText: null,
      isLoading: false,
      userSubscribed: true
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "openAddMembersModal", function () {
      _this.setState({
        showAddMembersModal: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "openEditFeaturedTopicsModal", function () {
      _this.setState({
        showEditFeaturedTopicsModal: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "leaveGroup", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                isLoading: true
              });

              _context.prev = 1;
              _context.next = 4;
              return (0, _service.leaveGroup)({
                groupId: _this.props.groupId,
                csrfToken: _this.props.csrfToken
              });

            case 4:
              _this.props.isHiddenGroup ? redirectToGroupsOverview() : pageReload();
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);

              _this.setState({
                isLoading: false
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "subscribe", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                isLoading: true
              });

              _context2.prev = 1;
              _context2.next = 4;
              return (0, _service.subscribeUser)({
                groupId: _this.props.groupId,
                csrfToken: _this.props.csrfToken
              });

            case 4:
              _this.setState({
                isLoading: false,
                userSubscribed: true
              });

              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);

              _this.setState({
                isLoading: false
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 7]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "unsubscribe", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this.setState({
                isLoading: true
              });

              _context3.prev = 1;
              _context3.next = 4;
              return (0, _service.unsubscribeUser)({
                groupId: _this.props.groupId,
                csrfToken: _this.props.csrfToken
              });

            case 4:
              _this.setState({
                isLoading: false,
                userSubscribed: false
              });

              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](1);

              _this.setState({
                isLoading: false
              });

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 7]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onManageGroupClick", function () {
      window.location.href = (0, _absoluteUrlRuntime.resolveUrl)("/groups/".concat(_this.props.groupId, "/moderation?view=members"));
    });
    return _this;
  }

  (0, _createClass2.default)(GroupActionButtons, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var _e$response;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.props.isCurrentUserMember) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                _context4.prev = 2;
                _context4.next = 5;
                return (0, _service.checkUserSubscribed)(this.props.groupId);

              case 5:
                this.setState({
                  userSubscribed: true
                });
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](2);

                if (((_e$response = _context4.t0.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === _service.STATUS_USER_UNSUBSCRIBED) {
                  this.setState({
                    userSubscribed: false
                  });
                }

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 8]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          groupId = _this$props.groupId,
          curatedContentTitle = _this$props.curatedContentTitle,
          curatedContentTopics = _this$props.curatedContentTopics,
          isCurrentUserModerator = _this$props.isCurrentUserModerator,
          isCurrentUserMember = _this$props.isCurrentUserMember,
          communityLocale = _this$props.communityLocale,
          onAddMembers = _this$props.onAddMembers;
      var _this$state = this.state,
          showAddMembersModal = _this$state.showAddMembersModal,
          showEditFeaturedTopicsModal = _this$state.showEditFeaturedTopicsModal,
          showMessage = _this$state.showMessage,
          messageStatus = _this$state.messageStatus,
          messageText = _this$state.messageText,
          userSubscribed = _this$state.userSubscribed,
          isLoading = _this$state.isLoading;
      var moderatorActions = [{
        className: 'user-action__group-add-member-btn',
        action: this.openAddMembersModal,
        elementName: 'Group Clicked add members',
        text: 'groups.add.members'
      }, {
        className: 'user-action__group-manage-btn',
        action: this.onManageGroupClick,
        elementName: 'Group Clicked manage groups on the destination',
        text: 'groups.manage.group'
      }, {
        className: 'user-action__group-edit-featured-topics-btn',
        action: this.openEditFeaturedTopicsModal,
        elementName: 'Group Clicked change featured topics',
        text: 'groups.edit.featured.content'
      }];
      return (0, _preact.h)("div", {
        className: "group-details_hero__user-actions"
      }, isCurrentUserMember ? (0, _preact.h)("div", {
        className: "group-details_hero__user-actions__member-actions"
      }, (0, _preact.h)("a", {
        type: "button",
        className: (0, _classnames.default)('btn--cta', 'create-group-topic-btn', 'is-hidden-S'),
        href: (0, _absoluteUrlRuntime.resolveUrl)("/topic/new?fid=".concat(groupId))
      }, (0, _preact.h)(_phrase.default, {
        p: "main.navigation.add_topic"
      })), (0, _preact.h)("div", {
        className: (0, _classnames.default)('group-details_hero__user-joined', 'btn', 'btn--secondary')
      }, (0, _preact.h)("span", {
        "aria-hidden": "true",
        className: "group-details_hero__user-joined-icon"
      }, (0, _preact.h)(_CheckInCircle.default, {
        width: 24,
        height: 24,
        fill: "#3CB54A"
      })), (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
        p: "groups.joined"
      })))) : null, (0, _preact.h)(_index.default, {
        size: "S",
        align: "right",
        popupName: "group-actions-list",
        disabled: isLoading,
        trigger: (0, _preact.h)(_Button.default, {
          type: "button",
          size: "medium",
          oldStyle: true,
          className: (0, _classnames.default)('btn', 'btn--secondary', 'group-details_hero__user-action-dropdown-btn', 'groups-v2-styles'),
          isLoading: isLoading,
          disabled: isLoading
        }, (0, _preact.h)(_MoreHoriz.default, {
          className: "icon-dropdown",
          width: 24
        }))
      }, isCurrentUserModerator ? moderatorActions.map(function (action) {
        return (0, _preact.h)(_index.DropdownItem, {
          key: action.className
        }, (0, _preact.h)("button", {
          className: action.className,
          onClick: action.action,
          "data-bounded-context": "Groups",
          "data-entity": "manage-group",
          "data-track-type": "click",
          "data-element-name": action.elementName,
          disabled: isLoading
        }, (0, _preact.h)(_phrase.default, {
          p: action.text
        })));
      }) : null, isCurrentUserMember ? (0, _preact.h)(_index.DropdownItem, {
        key: "subscription-button-".concat(userSubscribed)
      }, userSubscribed ? (0, _preact.h)("button", {
        className: "user-action__group-subscription-btn",
        onClick: this.unsubscribe,
        disabled: isLoading
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.unsubscribe.from.notifications"
      })) : (0, _preact.h)("button", {
        className: "user-action__group-subscription-btn",
        onClick: this.subscribe,
        disabled: isLoading
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.subscribe.to.notifications"
      }))) : null, isCurrentUserMember ? (0, _preact.h)(_index.DropdownItem, {
        type: "alert"
      }, (0, _preact.h)("button", {
        className: "user-action__leave-group-btn",
        onClick: this.leaveGroup,
        disabled: isLoading
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.leave.group"
      }))) : null), showAddMembersModal ? (0, _preact.h)(_GroupAddMembersModal.default, {
        groupId: groupId,
        onClose: function onClose() {
          return _this2.setState({
            showAddMembersModal: false
          });
        },
        onAdd: function onAdd() {
          onAddMembers();
        },
        communityLocale: communityLocale,
        showMessage: function showMessage(status, message) {
          return _this2.setState({
            showMessage: true,
            messageStatus: status,
            messageText: message
          });
        }
      }) : null, showEditFeaturedTopicsModal ? (0, _preact.h)(_GroupEditFeaturedTopicsModal.default, {
        groupId: groupId,
        title: curatedContentTitle,
        featuredTopics: curatedContentTopics,
        onClose: function onClose() {
          return _this2.setState({
            showEditFeaturedTopicsModal: false
          });
        }
      }) : null, showMessage ? (0, _preact.h)(_message.default, {
        variant: messageStatus,
        onDismiss: function onDismiss() {
          return _this2.setState({
            showMessage: false
          });
        },
        timer: 5000
      }, messageText) : null);
    }
  }]);
  return GroupActionButtons;
}(_preact.Component);

exports.GroupActionButtons = GroupActionButtons;
var _default = GroupActionButtons;
exports.default = _default;